import { render } from "./AssignIncentivesDetails.vue?vue&type=template&id=f3c84860"
import script from "./AssignIncentivesDetails.vue?vue&type=script&lang=js"
export * from "./AssignIncentivesDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__